import 'bootstrap/dist/css/bootstrap.min.css'; 
import '../assets/css/ExpSection.css'
import Roll from 'react-reveal/Roll';

function ExpSection() {
    return (
        <div className="sec8 container">
            <h2>Experience</h2>
            <Roll right>
            <div className="row expSec">
              <div className="col exprows">
                <div className='row exprow row1'>
                    <div className="line">
                        <h2><b>Senior System Engineer at Infosys Limited</b></h2>
                        <h2 className='year'>Oct 2022 - Present</h2>
                    </div>
                    <div className="line">
                        <h2><b>System Engineer at Infosys Limited</b></h2>
                        <h2 className='year'>Mar 2021 - Sept 2022</h2>
                    </div>
                    <h2>Learn and develop projets using Java/Spring, GWT, Mysql etc.</h2>
                </div>
                <div className='row exprow row2'>
                    <div className="line">
                        <h2><b>Python Developer at Codemarket</b></h2>
                        <h2 className='year'>Jan 2021 - Feb 2021</h2>
                    </div>
                    <h2>Automation using Python Selenium.</h2>
                </div>
                <div className='row exprow row3'>
                    <div className="line">
                        <h2><b>Open Source Contributor at Hakincode</b></h2>
                        <h2 className='year'>Aug 2020 - Oct 2021</h2>
                    </div>
                    <h2>Contributed in Backend (Django), frontend (React, Html, Css) and UI Design.</h2>
                </div>
                <div className='row exprow row4'>
                    <div className="line">
                        <h2><b>Jr. Java Programmer Internship at Pouchtech Software Pvt.</b></h2>
                        <h2 className='year'>Dec 2019 - Feb 2020 </h2>
                    </div>
                    <h2>Learn about Java oops, Servlet and made mini projects on that.</h2>
                </div>
                <div className='row exprow row5'>
                    <div className="line">
                        <h2><b>Web Developer (Wordpress) at Technojack Info. Solution</b></h2>
                        <h2 className='year'>Dec 2018 - Jan 2019</h2>
                    </div>
                    <h2>Made a website using wordpress.</h2>
                </div>
              </div>
              
            </div>
            </Roll>
          </div>
        );
    }
    
export default ExpSection;